import { CHAIN_NAME, OPENSEA_URL } from "@constants/env";

export const getOpenSeaLink = (contractAddress: string, tokenId: string): string =>
    `${OPENSEA_URL}assets/${CHAIN_NAME}/${contractAddress}/${tokenId}`;
